"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var moment = require("moment");

require("moment/locale/it");

var _UiUtils = require("./UiUtils");

/**
 * @class
 * @classdesc Base class for all date formatings needed.<br/>
 * This class is used with a third party library wich is 'moment' so almost any output is processed with library.<br/>
 * ATTENTION! This is a SINGLETON CLASS so it should be accessed as common.DateFormatter.[methodName]
 * @constructor
 * 
 */
function DateFormatter() {}
/**
 * Partendo da un qualsiasi tipo di data, vi viene applicata la formattazione
 * come da documentazione della libreria Moment
 * @param {*} date stringa date, timestamp, oggetto moment ed oggetto Date.
 * @param {*} format stringa formato moment https://momentjs.com/docs/#/parsing/string-format/
 * 
 * @returns La data formattata, oppure null.
 */


DateFormatter.prototype.formatDate = function (date, format) {
  var toDate = this.toDateNew(date);

  if (toDate !== null && format && format !== null && format !== "") {
    return moment(toDate).format(format);
  }

  return toDate;
};
/**
 * Se il valore passato è una stringa che rappresenta un Date (formattata o non),
 * un timestamp o un oggetto Moment, ritorna l'oggetto javascript Date
 * @param {*} value valore rapprensentante la data
 * @returns se il valore è corretto, un oggetto Date, altrimenti null.
 */


DateFormatter.prototype.toDateNew = function (value) {
  if (value === undefined) {
    console.warn("[DateFormatter.toDate]: data non valorizzata");
    return null;
  }

  if (value === null) return null;
  if (value instanceof Date) return value;
  var date = new Date(value); //oggetto date convertito in stringa

  if (!isNaN(date)) return date;
  if (moment.isMoment(value)) return value.toDate();

  if (typeof value === "string") {
    date = moment(value, "x"); //verifico se è un timestamp

    if (date.isValid() && date.toDate().getTime() !== 0) return date.toDate();
  }

  console.warn("[DateFormatter.toDate]: data non corretta", {
    value: value
  });
  return null;
};
/**
 * Ritorna se le due date passate in ingresso sono uguali
 * indipendentemente dall'orario.
 * @param {*} date1 
 * @param {*} date2 
 * @returns moment(date1).isSame(date2);
 */


DateFormatter.prototype.equalsIngoreTime = function (date1, date2) {
  if (!date1 || !(date1 instanceof Date)) return 1;
  if (!date2 || !(date2 instanceof Date)) return 1;
  date1 = this.truncateTime(date1);
  date2 = this.truncateTime(date2);
  return moment(date1).isSame(date2);
};
/**
 * Compara le date passate in ingresso non considerando il Time.
 * Restituisce -1/0/1 con lo stesso meccanismo della compare di Java.
 * @param {Date} date1 
 * @param {Date} date2 
 * @returns if (moment(date1).isSame(date2)) return 0; <br/>
 *      else if (moment(date1).isBefore(date2)) return -1; <br/>
 *      else if (moment(date1).isAfter(date2)) return 1; <br/>
 */


DateFormatter.prototype.compareIngoreTime = function (date1, date2) {
  if (!date1 || !(date1 instanceof Date)) return 1;
  if (!date2 || !(date2 instanceof Date)) return 1;
  date1 = this.truncateTime(date1);
  date2 = this.truncateTime(date2);
  if (moment(date1).isSame(date2)) return 0;else if (moment(date1).isBefore(date2)) return -1;else if (moment(date1).isAfter(date2)) return 1;
};
/**
 * Prende in ingresso una data e ne restituisce una nuova
 * con ora, minuti e seondi azzerati.
 * 
 * @param date data da troncare
 * @returns date.setHours(0, 0, 0, 0)
 */


DateFormatter.prototype.truncateTime = function (date) {
  if (!date || !(date instanceof Date)) return null;
  return date.setHours(0, 0, 0, 0);
};
/**
 * 
 * @param {*} stringa 
 * @returns La stringa come Data
 */


DateFormatter.prototype.toDate = function (stringa) {
  // console.log('\t[toDate] armundia.js - TODATE ' + stringa);
  if (stringa instanceof Date) {
    //      console.log("\ttoDate invece di una stringa ho ricevuto una data! ");
    //    console.log('\ttoDate it-IT: ' + new Intl.DateTimeFormat('it-IT', { year: 'numeric', month: '2-digit', day: '2-digit' }).format(stringa));
    return stringa;
  }

  if (stringa === null) {
    //   console.log('\t[toDate] stringa null --> return ');
    return "-";
  }

  var parts = [];

  if (stringa.indexOf("-") < 0) {
    parts[0] = stringa.substring(0, 4);
    parts[1] = stringa.substring(4, 6);
    parts[2] = stringa.substring(6, 8); //console.log("data stringa " + stringa + " part0 " + parts[0]+ " part1 " + parts[1] + " part2 " + parts[2])
    //rrutigliano   //"20151130"

    parts[1] = parts[1] - 1;
  } else {
    //console.log('\t[toDate] stringa: ' + stringa);
    parts = stringa.split("-");
    parts[1] = parts[1] - 1;
  }

  if (parts.length !== 3) {
    throw 'Errore nel formato della data:' + stringa;
  }

  var myDate = null; //    console.log('\parts[2]: ' + parts[2]);
  //  console.log('\parts[1]: ' + parts[1]);
  //console.log('\parts[0]: ' + parts[0]);

  myDate = new Date(parts[0], parts[1], parts[2]); //let myDateFormat = new Intl.DateTimeFormat('it-IT', { year: 'numeric', month: '2-digit', day: '2-digit' }).format(myDate);
  //console.log('\ttoDate risultato: ' + myDateFormat);

  return myDate;
};
/**
 * 
 * @param {String} aaaammgg format of the string should be 'YYYYMMDD' Y-year M-month D-day
 * @returns {Date} The date from the date passed in input with the given format
 */


DateFormatter.prototype.toDateFromInt = function (aaaammgg) {
  if (aaaammgg === null || aaaammgg === undefined || isNaN(aaaammgg)) return "";
  var parts = [];
  parts[0] = Math.floor(aaaammgg / 10000);
  parts[1] = Math.floor(aaaammgg % 10000 / 100) - 1;
  parts[2] = aaaammgg % 100;
  var myDate = null;
  myDate = new Date(parts[0], parts[1], parts[2]);
  return myDate;
};
/**
 * 
 * @param {String} aaaammgg format of the string should be 'YYYYMMDD' Y-year M-month D-day
 * @param {String} locale locale example: 'it-IT'
 * @returns {Date} The date from the date passed in input with the given format
 */


DateFormatter.prototype.formatIntDate = function (aaaammgg, locale) {
  var myDate = null;
  myDate = this.toDateFromInt(aaaammgg);
  if (!locale) locale = "it-IT"; // TODO default?!

  var myDateFormat = new Intl.DateTimeFormat(locale, {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  }).format(myDate);
  return myDateFormat;
};
/**
 * 
 * @param {*} value 
 * @param {*} defValue 
 * @param {*} locale 
 */


DateFormatter.prototype.dataFormatter = function (value, defValue, locale) {
  if (value === undefined || value === null || value === '') {
    return defValue ? defValue : "-";
  }

  if (!locale) locale = "it-IT"; // TODO default?!

  return new Intl.DateTimeFormat(locale, {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric'
  }).format(value);
};
/**
 * 
 * @param {*} value 
 * @param {*} defValue 
 * @param {*} locale 
 */


DateFormatter.prototype.dataFormatterShort = function (value, defValue, locale) {
  if (value === undefined || value === null || value === '') {
    return defValue ? defValue : "-";
  }

  if (!locale) locale = _UiUtils.default.defaultLocale();

  try {
    return new Intl.DateTimeFormat(locale, {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    }).format(value);
  } catch (error) {
    console.warn("Errore in formattazione data " + value, error);
    return value;
  }
};
/**
 * 
 * @param {*} data 
 * @param {*} defValue 
 */


DateFormatter.prototype.dateISO = function (data, defValue) {
  if (data === undefined || data === null) return defValue ? defValue : null;
  var myDateISO; // if (data instanceof Date) {
  //   myDateISO = data.toISOString();
  //} else {
  //nel caso di date nel formato numerico ... millisecondi
  //myDateISO = moment(data).toDate().toISOString();
  //}
  //Rutigliano 26/07/2017
  //devo escludere le informazioni sul time zone
  //console.log("UTC:" + moment.utc(data));
  //console.log("utcOffset: " + moment().utcOffset());
  //console.log("timeZonecOffset: " + moment().zone());

  myDateISO = moment(data).format("YYYY-MM-DDTH:mm:ss.000") + "Z"; //console.log("[DateFormatter] dateISO: " + myDateISO);
  //myDateISO = moment(data).toISOString();
  //console.log("[DateFormatter] dateISO: " + myDateISO);

  return myDateISO;
};
/**
 * 
 * @param {*} data 
 * @param {*} defValue 
 */


DateFormatter.prototype.dateCheckShort = function (data, defValue) {
  if (data === undefined || data === null) return defValue ? defValue : null;
  var dt;
  dt = moment(data).format("YYYY-MM-DD");
  return dt;
};
/**
 * 
 * @param {Date} date The date to wich add the months
 * @param {Number} months Months to add
 * @returns {Date} The date with the added months
 */


DateFormatter.prototype.addMonths = function (date, months) {
  //console.log("[armundia.js] addMonths " + months + " to date : " + this.dataFormatter(date));
  var d = moment(date);
  d.add(months, 'months'); //console.log(" \t return addMonths " + this.dataFormatter(d.toDate()));

  return d.toDate();
};
/**
 * 
 * @param {*} date The date to wich add the days
 * @param {*} days Days to add
 * @returns {Date} The date with the added days
 */


DateFormatter.prototype.addDays = function (date, days) {
  //console.log("[armundia.js] days " + days + " to date : " + this.dataFormatter(date));
  var d = moment(date);
  d.add(days, 'days'); //console.log(" \t return days " + this.dataFormatter(d.toDate()));

  return d.toDate();
};
/**
 * Ritorna la differenza tra due date in base al tipo passato in ingresso.
 * Se non si passa il tipo ritorna la differenza in giorni. (tipo = days)
 * 
 * @param {*} data1 
 * @param {*} data2 
 * @param {*} tipo sono validi i tipi gestiti da momentjs (days...)
 */


DateFormatter.prototype.dateDiff = function (data1, data2, tipo) {
  if (!tipo) tipo = 'days';
  var a = moment(data1);
  var b = moment(data2);
  return a.diff(b, 'days');
};
/**
 * 
 * @param {*} data1 
 * @param {*} data2 
 * @param {*} tipo 
 */


DateFormatter.prototype.dateDiffInDays = function (data1, data2, tipo) {
  //let _PER_DAY = 1000 * 60 * 60 * 24;
  if (!tipo) tipo = 'days';
  var a = moment(data1);
  var b = moment(data2);
  return b.diff(a, 'days') + 1;
};
/**
 * Restituisce il giorno lavorativo distante days da oggi, considerando come giorni festivi i sabati e le domeniche.
 * Esempio psOggi(-1) restituisce la data di ieri se oggi non è domenica o lunedì, altrimenti restituisce il venerdì precedente.
 * @param {*} days 
 */


DateFormatter.prototype.psOggi = function (days) {
  return this.psGiorno(new Date(), days);
};
/**
 * Restituisce il giorno lavorativo distante days da date, considerando come giorni festivi i sabati e le domeniche.
 * Esempio psGiorno(new Date(), -1) restituisce la data di ieri se oggi non è domenica o lunedì, altrimenti restituisce il venerdì precedente.
 * @param {*} date 
 * @param {*} days 
 */


DateFormatter.prototype.psGiorno = function (date, days) {
  var d = new Date(date);

  if (days !== 0) {
    d = this.addDays(d, days);

    while (d.getDay() === 0 || d.getDay() === 6) {
      d = this.addDays(d, days > 0 ? 1 : -1);
    }
  }

  return d;
};
/**
 * Restituisce il primo lunedì precedente distante days da date.
 * Esempio psIniSett(new Date(), 0) restituisce la data odierna se oggi è lunedì, altrimenti restituisce il lunedì della settimana corrente.
 * @param {*} date 
 * @param {*} days 
 */


DateFormatter.prototype.psIniSett = function (date, days) {
  var d = new Date(date);
  d = this.addDays(d, days);
  d = this.addDays(d, -((d.getDay() - 1) % 7));
  return d;
};
/**
 * Restituisce il primo giorno del mese distante months da date.
 * Esempio psIniMese(new Date(), -1) restituisce il primo giorno del mese scorso.
 * @param {*} date 
 * @param {*} months 
 */


DateFormatter.prototype.psIniMese = function (date, months) {
  var d = new Date(date);
  d = this.addMonths(d, months);
  d.setDate(1);
  return d;
};
/**
 * Restituisce il primo giorno del trimestre distante months da date.
 * Esempio psIniTrim(new Date(), -1) restituisce il primo giorno del trimestre relativo allo scorso mese.
 * @param {*} date 
 * @param {*} months 
 */


DateFormatter.prototype.psIniTrim = function (date, months) {
  var d = new Date(date);
  var m = d.getMonth() + months;
  m = Math.floor((m + 2) / 3);
  m = m + 2 * (m - 1);
  d.setMonth(m);
  d.setDate(1);
  return d;
};
/**
 * Restituisce il primo giorno dell'anno distante years da date.
 * Esempio psIniAnno(new Date(), 1) restituisce il primo giorno del prossimo anno.
 * @param {*} date 
 * @param {*} years 
 */


DateFormatter.prototype.psIniAnno = function (date, years) {
  var d = new Date(date);
  d.setFullYear(d.getFullYear() + years);
  d.setMonth(0);
  d.setDate(1);
  return d;
};
/**
 * Restituisce l'ultimo giorno, si può scegliere se lavorativo o no, del mese distante months da date.
 * Esempio psFineMese(new Date(), -1, true) restituisce l'ultimo giorno lavorativo del mese scorso.
 * @param {*} date 
 * @param {*} months 
 * @param {*} working 
 */


DateFormatter.prototype.psFineMese = function (date, months, working) {
  var d = new Date(date);
  d = this.addMonths(d, months + 1);
  d.setDate(1);
  d = working ? this.psGiorno(d, -1) : this.addDays(d, -1);
  return d;
};
/**
 * Restituisce l'ultimo giorno, si può scegliere se lavorativo o no, del trimestre distante months da date.
 * Esempio psFineTrim(new Date(), -1, true) restituisce l'ultimo giorno lavorativo del trimestre relativo allo scorso mese.
 * @param {*} date 
 * @param {*} months 
 * @param {*} working 
 */


DateFormatter.prototype.psFineTrim = function (date, months, working) {
  var d = new Date(date);
  d = this.psIniTrim(d, months + 3);
  d = working ? this.psGiorno(d, -1) : this.addDays(d, -1);
  return d;
};
/**
 * Restituisce l'ultimo giorno, si può scegliere se lavorativo o no, dell'anno distante years da date.
 * Esempio psFineAnno(new Date(), 1, false) restituisce il 31 dicembre del prossimo anno.
 * @param {*} date 
 * @param {*} years 
 * @param {*} working 
 */


DateFormatter.prototype.psFineAnno = function (date, years, working) {
  var d = new Date(date);

  if (working) {
    d = this.psIniAnno(d, years + 1);
    d = this.psGiorno(d, -1);
  } else {
    d.setFullYear(d.getFullYear() + years);
    d.setMonth(11);
    d.setDate(31);
  }

  return d;
};
/**
 * 
 * @param {*} value 
 * @param {*} def 
 */


DateFormatter.prototype.short = function (value, def) {
  if (value === undefined || value === null || value === '') {
    return def || "-";
  }

  var locale = "it"; // TODO get from GLOBAL i18n (based on browser, prefs, app, ecc.)

  return moment(value).locale(locale).format("L");
};
/**
 * 
 * @param {*} value 
 */


DateFormatter.prototype.parseDate = function (value) {
  if (value === undefined || value === null) {
    return null || "-";
  }

  return moment(value, 'DD/MM/YYYY').toDate();
};
/**
 * 
 * @param {*} value 
 * @param {*} format 
 */


DateFormatter.prototype.parseDateWithFormat = function (value, format) {
  if (!value || !format || typeof format !== 'string') {
    return "-";
  }

  return moment(value, format).toDate();
};
/* parseDate(value, format) {
     if(value === undefined || value === null){
         return null || "-";
     }
     return moment(value, format).toDate()
 }*/

/**
 * 
 * @param {*} value 
 * @param {*} format 
 * @param {*} def 
 */


DateFormatter.prototype.parseTimestamp = function (value, format, def) {
  if (!value || format && typeof format !== 'string') {
    return def || "-";
  }

  if (!format) {
    format = "YYYY-MM-DD";
  }

  return moment(value, format).toDate();
};
/**
 * 
 * @param {*} data 
 * @param {*} format 
 */


DateFormatter.prototype.formatDateFromMilisToString = function (data, format) {
  if (data === undefined || data === null || data === "") {
    return "-";
  }

  if (!format || typeof format !== 'string') {
    format = "YYYY-MM-DD";
  }

  var dataFormatata = moment(parseInt(data)).format(format);
  return dataFormatata;
};

var exp = new DateFormatter();
var _default = exp;
exports.default = _default;